import React from "react";

import { cn } from "../../utils/utils";

const TransactionInfoCard = ({ label, value, className = "" }) => (
  <div
    className={cn(
      " col-span-2 md:col-span-1 flex items-center gap-2 bg-secondary-10 mt-2 rounded-v-lg p-2",
      className,
    )}
  >
    <p className="text-title-md-semibold-UL">{label}:</p>
    {value ? <p className="bg-secondary-10 shadow-md rounded-md p-[2px] px-1">{value}</p> : "-"}
  </div>
);

export default TransactionInfoCard;
